import { IconNew, ModBox, SpacerNew } from '@jfs/ui-new'
import React from 'react'

const EditDelete = React.memo(({ onDelete, onEdit, item }: any) => {
  const onEditPress = () => {
    onEdit && onEdit(item)
  }
  const onDeletePress = () => {
    onDelete && onDelete(item)
  }
  return (
    <ModBox flexDirection={'row'} alignItems={'flex-end'}>
      <ModBox
        alignItems={'center'}
        justifyContent={'center'}
        width={32}
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        onPress={onEditPress}
        underlayColor={'DISABLED_GREY'}>
        <IconNew id={'EDIT'} color={'BLACK_21'} />
      </ModBox>
      <SpacerNew direction="horizontal" size={16} />
      <ModBox
        alignItems={'center'}
        justifyContent={'center'}
        width={32}
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        onPress={onDeletePress}
        underlayColor={'DISABLED_GREY'}>
        <IconNew id={'DELETE'} color={'BLACK_21'} />
      </ModBox>
    </ModBox>
  )
})

export { EditDelete }
